const setTokenList = (state, payload) => {
  state.tokenList = payload.data || []
}

const revokeToken = (state, id) => {
  const token = state.tokenList.find(t => t.id === id)
  if (token) token.status = 'revoked'
}

export default {
  setTokenList,
  revokeToken
}



// WEBPACK FOOTER //
// ./src/store/modules/integrationTokens/mutations.js